import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { appTheme, showKudzuPlusPrompt } from '../../../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../../../../Redux/selectors';


const SuccessTransfer = ({ onCanelTranfer, isCancelButton,fromAccountType,showPlusAlertforSuccessTransfer }) => {
    const { t } = useTranslation();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue)
    const location = useLocation();
    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
     const isinSavings = location.pathname.toLocaleLowerCase().includes("savings");
    const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);

    const accountServicesPath = '/AccountServices';
    const manageMoneyPath = '/ManageMoney';

    return (
        <div className=' flex flex-col justify-center items-center w-full'>
            <img src={appThemeData.TransactionComplete} alt="Transaction complete" className={`${kudzuPlusTrue ? 'mb-12 mt-auto mx-auto' :'lg:w-[220px] lg:h-[220px] md:w-[170px] md:h-[170px] w-[129px] h-[129px] sm:m-auto mx-auto'} block`} />
            {isTransferMoneyFeatureEnabled ? (
                <div className=' flex flex-col justify-center items-center w-full'>
                    <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                        <Link to={manageMoneyPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] bg-[#2965FB] text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_manage_money")}</Link>
                   </div>
                </div>
            ) : (
                    <div className=' flex flex-col justify-center items-center w-full'>

                        <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                            <Link to={accountServicesPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] bg-[#2965FB] text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_account_services")}</Link>
                            {isCancelButton &&
                                <button type="button" className="font-hanken-grotesk text-[12px] font-[500] sm:font-bold leading-[12px] sm:text-[12px] sm:leading-[12px] md:text-[16px] md:leading-[16px] text-[var(--transferBtnTextColor)] cursor-pointer  px-2 py-4 w-full" onClick={() => onCanelTranfer(true)}>{t("cancel_tranfer")}</button>
                            }
                        </div>
                    </div>
            )}
            

        </div>
    )
}

export default SuccessTransfer